import { useMemo, useCallback } from "react";
import { useAuth } from "../providers/AuthProvider";
import {
  flattenComponentConfig,
  normalizeComponentConfig,
} from "../config/accessConfig";

export default function useModules() {
  const { user } = useAuth();

  const components = useMemo(() => {
    if (user?.enabled_components && typeof user.enabled_components === "object") {
      return normalizeComponentConfig(user.enabled_components);
    }
    return {
      email: ["outlook"],
    };
  }, [user?.enabled_components]);

  const enabled = useMemo(() => Object.keys(components || {}), [components]);

  const componentKeys = useMemo(
    () => flattenComponentConfig(components),
    [components],
  );

  const has = useCallback(
    (moduleKey) => {
      if (!moduleKey) return true;

      if (Array.isArray(moduleKey)) {
        return moduleKey.some((m) => enabled.includes(m));
      }

      return enabled.includes(moduleKey);
    },
    [enabled],
  );

  const hasComponent = useCallback(
    (componentKey) => {
      if (!componentKey) return true;

      if (Array.isArray(componentKey)) {
        return componentKey.some((component) => componentKeys.includes(component));
      }

      return componentKeys.includes(componentKey);
    },
    [componentKeys],
  );

  return { enabled, components, has, hasComponent };
}
